import { HiX } from 'react-icons/hi';
import { Layer, Popup, Source } from 'react-map-gl';

import CustomMap from 'components/elements/customMap';
import NumberText from 'components/elements/numberText';
import { useHpiMapModal } from '../hooks/useHpiMapModal';
import { useEffect, useState } from 'react';
import { Data } from '../../../../lib/apis/services/insight/type';

type Props = {
  closeModal: (() => void) | undefined;
  locationId: string;
  locationType: string;
};

const HousePricesDetailMapModal = ({ closeModal, locationId, locationType }: Props) => {
  const {
    mapLoadHandler,
    mapEventHandler,
    mapRef,
    data: geoLocation,
    states,
    h3Data,
    showpopup,
    setShowpopup,
    processH3Cells,
  } = useHpiMapModal(locationId, locationType);

  const [data, setData] = useState<Data | null>(null);
  useEffect(() => {
    if (geoLocation !== undefined && geoLocation !== null) {
      setData(geoLocation);
    }
  }, [geoLocation]);

  return (
    <>
      <div className='relative w-[90vw] h-[90vh]'>
        <button
          className='btn btn-sm btn-primary absolute top-4 left-4 z-10 !p-2'
          onClick={closeModal}
        >
          <HiX size={25} />
        </button>
        {data !== null && (
          <CustomMap
            onLoad={mapLoadHandler}
            onDragEnd={mapEventHandler}
            onZoomEnd={(e) => mapEventHandler(e, 'zoom')}
            onRotateEnd={mapEventHandler}
            key={'modal_market_insight_map'}
            ref={mapRef}
            initialViewState={{
              latitude: data.data.point.coordinate[1],
              longitude: data.data.point.coordinate[0],
              zoom: locationType === 'REGION' ? 12 : states.zoomLevel,
            }}
            style={{ width: '100%', height: '100%' }}
          >
            {data.data.polygon.coordinates.length > 0 && (
              <Source
                type='geojson'
                data={{
                  type: 'FeatureCollection',
                  features: [
                    {
                      type: 'Feature',
                      properties: {},
                      geometry: {
                        type: 'Polygon',
                        coordinates: [data.data.polygon.coordinates],
                      },
                    },
                  ],
                }}
              >
                <Layer
                  {...{
                    id: 'data',
                    type: 'fill',
                    paint: {
                      'fill-color': '#2681EF',
                      'fill-opacity': 0.3,
                    },
                  }}
                />
              </Source>
            )}
            {h3Data && (
              <Source
                id='h3DataSource'
                type='geojson'
                data={{
                  type: 'FeatureCollection',
                  features: processH3Cells as any,
                }}
              >
                <Layer
                  {...{
                    id: 'h3DataLayer',
                    type: 'fill',
                    paint: {
                      'fill-outline-color': 'white',
                      'fill-color': ['get', 'color'],
                      'fill-opacity': ['get', 'opacity'],
                    },
                  }}
                />
              </Source>
            )}
            {showpopup && states?.popup?.price && (
              <Popup
                longitude={states.popup.lng || 0}
                latitude={states.popup.lat || 0}
                onClose={() => setShowpopup(false)}
                className='p-4 min-w-max'
                closeButton={false}
              >
                <div className='flex items-center justify-center p-3 pl-5 text-lg min-w-max app-font-family'>
                  <span>میانگین قیمت:</span>&nbsp;
                  <span className='text-primary-500'>
                  <NumberText>
                    {states.popup.price?.toString() || ''}
                  </NumberText>
                    &nbsp; تومان
                </span>
                </div>
              </Popup>
            )}
          </CustomMap>
        )}
      </div>
    </>
  );
};

export default HousePricesDetailMapModal;
